export const REDIRECT_TO_URL = '[ROUTING] REDIRECT_TO_URL';
export const REDIRECT_BACK = '[ROUTING] REDIRECT_BACK';
export const REDIRECT_REPLACE = '[ROUTING] REDIRECT_REPLACE';
